import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProductForm from "../ProductForm/ProductForm";
import LoadingIndicator from "@/components/LoadingIndicator/LoadingIndicator";
import { useProductEditPage } from "../../hooks/useProductEditPage";

const ProductEditPage: React.FC = () => {
  const { currentProduct, loading, isSubmitting, handleSubmit } =
    useProductEditPage();

  if (loading && !currentProduct) {
    return (
      <div className="p-6 max-w-3xl mx-auto">
        <LoadingIndicator />
      </div>
    );
  }

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <Link
        className="inline-flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white mb-6 transition-colors"
        to="/lead-generation/product-store/products"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Products
      </Link>

      <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg p-6">
        <div className="mb-6">
          <h1 className="text-lg font-normal text-gray-900 dark:text-white">
            Edit Product
          </h1>
        </div>

        <ProductForm
          initialData={currentProduct}
          isLoading={isSubmitting}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default ProductEditPage;
